import { Form } from '@/shared/form/form';
import { classInstance } from '@/shared/helpers/helpers';

export class ModalAuth {
	constructor(selector) {
		this.$container = selector;
		if (!this.$container) return;
		this.init();
	}

	init() {
		this.authByEmailForm = this.$container.querySelector('.js-singin-email-form');

		this.emailInput = this.authByEmailForm?.querySelector('.form-input[type="email"]');
		this.emailInputInstance = classInstance.get(this.emailInput)?.formElement;

		if (this.authByEmailForm) {
			this.authByEmailFormInstance = new Form(this.authByEmailForm);
		}

		this.resetStartAnimation();
		this.authByEmailForm?.addEventListener('submit', this.submitByEmailHandler);
	}

	resetStartAnimation() {
		setTimeout(() => {
			this.$container.classList.remove('hidden');
		}, 2000);
	}

	showEmailInputError = (message) => this.emailInputInstance.renderError(message);

	submitByEmailHandler = (event) => {
		event.preventDefault();

		if (!this.authByEmailFormInstance.formCheck(false)) {
			return;
		}

		this.$container.dispatchEvent(
			new CustomEvent('submitEmail', {
				detail: {
					data: new FormData(this.authByEmailForm),
				},
			}),
		);
	};
}
